export default class StaticClass {
    constructor() {
        if (this instanceof StaticClass) {
            throw Error("A static class cannot be instantiated.");
        }
    }
}
